import React from 'react';
import { Row, Col, Divider } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import styles from './index.module.less';
import exclamation from './exclamation.png';
import guide from './guide.png';
import Button from '../Button';
import CardLayout from '../../../layouts/CardLayout';
import { Link } from '../../../utils/i18n';
import TrackClick from '../../../components/Onetrack/TrackClick';
import TrackView from '../../../components/Onetrack/TrackView';

const BeforeStart: React.FC = () => {
  const history = useHistory();
  const { search } = history.location;
  return (
    <TrackView tip="71.3.0.1.2154">
      <CardLayout title={<FormattedMessage id="Contact.Privacy.Team" />}>
        <div className={styles.start}>
          <div className={styles.title}>
            <img alt="exclamation" className={styles.exclamation} src={exclamation} />
            <FormattedMessage id="Contact.Start.Notice" />
          </div>
          <Row gutter={56}>
            <Col lg={0} md={24} xs={24}>
              <img alt="guide" className={styles.image} src={guide} />
            </Col>
            <Col xl={14} lg={12} xs={24}>

              <div className={styles.content}>
                <FormattedMessage id="Contact.Start.Text1" />
                <br />
                <br />
                <FormattedMessage id="Contact.Start.Text2" />
              </div>
            </Col>
            <Col xl={10} lg={12} xs={0}>
              <img alt="guide" className={styles.image} src={guide} />
            </Col>
          </Row>
          <Divider />
          <div className={styles.tips}>
            <FormattedMessage
              id="Contact.Start.Help"
              values={{
                service: (
                  <TrackClick tip="71.3.0.1.2156">
                    <Link to="/service">
                      <FormattedMessage id="Service" />
                    </Link>
                  </TrackClick>
                ),
              }}
            />
          </div>
          <TrackClick tip="71.3.0.1.2155">
            <Button onClick={() => history.push({ pathname: '/contact/category', search })} className={styles.button} type="primary">
              <FormattedMessage id="Contact.Start.Ready" />
            </Button>
          </TrackClick>
        </div>
      </CardLayout>
    </TrackView>
  );
};

export default BeforeStart;
